import * as React from 'react';
import { observer } from 'mobx-react';
import { serviceNames, diContainer } from '../../../service-setup/diContainer';
import { ProductFiltersViewController } from '../../controllers/ProductFiltersViewController';
import styled from 'styled-components';
import { Body1, Subtitle1 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import { translate } from 'elc-service';
import { MobileFiltersModal } from './MobileFiltersModal';
import { Button } from 'elc-buttons';
import { IFiltersTranslation } from './DesktopFilters';
import { RemoveIcon } from 'elc-icons';
import { classes } from '../../utils/Classes';
import { IProductGridFilters } from '../product-grid/ProductGridFilters';
import { FiltersSets } from './components/FiltersSets';
import { FilterSet } from '../../domain/entities/FilterSet';
import { ClearAllFilters } from './components/ClearAllFilters';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const FiltersTitle = styled(Subtitle1)`
    padding-bottom: ${ContentSpacing.space20};
`;

const ModalCTAContainer = styled.div``;

@translate([
    'filtersLabel',
    'filterByLabel',
    'applyFiltersLabel',
    'removeIconAriaLabel',
    'collapseIconAriaLabel',
    'expandIconAriaLabel'
])
@observer
class MobileFilters extends React.Component<IProductGridFilters> {
    private productFiltersViewController: ProductFiltersViewController;

    constructor(props: IProductGridFilters) {
        super(props);
        this.productFiltersViewController = diContainer.get(
            serviceNames.productFiltersViewController
        );
    }

    private handleFilterSetToggle(filterSet: FilterSet) {
        filterSet.toggleOpenState();
    }

    private clearAllFilters = () => {
        this.productFiltersViewController.onClearAllAppliedFilters(this.props.appliedFilters);
    };

    public render() {
        const { data, onOpenFiltersClick, onCloseFiltersClick } = this.productFiltersViewController;
        const { filtersLabel, applyFiltersLabel, filterByLabel, removeIconAriaLabel } = this.props
            .translations as IFiltersTranslation;

        const { isFilterInProgress, isFiltersModalOpen } = data;
        const applyFiltersClassname = classes('mobile-apply-filter-button');
        const applyFiltersLabelClassnames = classes('mobile-apply-filter-label');
        const mobileTagFiltersTitleClassnames = classes('mobile-category-filters-title');
        const removeIconWrapperClassnames = classes('mobile-category-filters-remove-icon-wrapper');
        const headerWrapperClassnames = classes('mobile-category-filters-header-wrapper');
        const ctaWrapperClassnames = classes('mobile-filters-cta');

        return (
            <MobileFiltersModal
                filtersLabel={filtersLabel}
                isFiltersModalOpen={isFiltersModalOpen}
                onOpenFilters={onOpenFiltersClick}
                onCloseFilters={onCloseFiltersClick}
                totalAppliedFilters={this.props.totalAppliedFilters}
            >
                <HeaderWrapper className={headerWrapperClassnames}>
                    <FiltersTitle className={mobileTagFiltersTitleClassnames}>
                        {filterByLabel}
                    </FiltersTitle>
                    <Button
                        className={removeIconWrapperClassnames}
                        onClick={onCloseFiltersClick}
                        aria-label={removeIconAriaLabel}
                    >
                        <RemoveIcon />
                    </Button>
                </HeaderWrapper>
                <FiltersSets
                    filterSets={this.props.filterSets}
                    handleFilterSetToggle={this.handleFilterSetToggle}
                    showFiltersWhenToggled
                    checkboxFilters
                    alwaysOn={false}
                />
                <ModalCTAContainer className={ctaWrapperClassnames}>
                    {this.props.appliedFilters.length ? (
                        <ClearAllFilters onClick={this.clearAllFilters} />
                    ) : null}
                    <Button
                        disabled={isFilterInProgress}
                        onClick={onCloseFiltersClick}
                        className={applyFiltersClassname}
                    >
                        <Body1 className={applyFiltersLabelClassnames}>{applyFiltersLabel}</Body1>
                    </Button>
                </ModalCTAContainer>
            </MobileFiltersModal>
        );
    }
}

export { MobileFilters };
